export default __webpack_public_path__ + "static/media/Headdress of the Blood God (nm).66658c7c.jpg";